import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "action-layer" }

import EffectsCarouselPreloaderVue from '@/components/effect/EffectsCarouselPreloader.vue'
import ActionMenu from '@/components/action-menu/ActionMenu.vue'
import BackgroundGallery from '@/components/background/BackgroundGallery.vue'
import TextGallery from '@/components/text/TextGallery.vue'
import StickerGallery from '@/components/sticker/StickerGallery.vue'
import EffectsGallery from '@/components/effect/EffectGallery.vue'
import { useApplicationStore, ActionMenuTabs } from '@/store/application-store'
import ImageGeneratorPanel from '@/components/background/ImageGeneratorPanel.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionLayer',
  setup(__props) {

const applicationStore = useApplicationStore()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(EffectsCarouselPreloaderVue),
    _createElementVNode("div", {
      class: _normalizeClass(['action-layer__galleries', {'action-layer__galleries--disabled': _unref(applicationStore).isImageGeneratorPanelOpen}])
    }, [
      _createVNode(ActionMenu),
      _withDirectives(_createVNode(BackgroundGallery, { class: "action-layer__gallery" }, null, 512), [
        [_vShow, _unref(applicationStore).activeActionTab === _unref(ActionMenuTabs).BACKGROUND]
      ]),
      _withDirectives(_createVNode(TextGallery, { class: "action-layer__gallery" }, null, 512), [
        [_vShow, _unref(applicationStore).activeActionTab === _unref(ActionMenuTabs).TEXT]
      ]),
      _withDirectives(_createVNode(StickerGallery, { class: "action-layer__gallery" }, null, 512), [
        [_vShow, _unref(applicationStore).activeActionTab === _unref(ActionMenuTabs).STICKERS]
      ]),
      _withDirectives(_createVNode(EffectsGallery, { class: "action-layer__gallery" }, null, 512), [
        [_vShow, _unref(applicationStore).activeActionTab === _unref(ActionMenuTabs).EFFECTS]
      ])
    ], 2),
    _createVNode(_Transition, { name: "action-layer__slide-transition" }, {
      default: _withCtx(() => [
        (_unref(applicationStore).isImageGeneratorPanelOpen)
          ? (_openBlock(), _createBlock(ImageGeneratorPanel, {
              key: 0,
              class: "action-layer__image-generator-panel",
              onClosePanel: _cache[0] || (_cache[0] = ($event: any) => (_unref(applicationStore).isImageGeneratorPanelOpen = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})